import styled from 'styled-components'
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import theme from 'src/styles/theme'
import { Button, TextField } from '@mui/material'
import TextFieldMui from 'src/components/TextFieldMui'

export const UploadIcon = styled(DriveFolderUploadIcon)`
    color: ${theme.colors.white} !important;
`

export const DeleteIcon = styled(DeleteOutlineIcon)`
    color: ${theme.colors.red} !important;
`

export const ListCustom = styled.li`
    list-style: none;
    background-color: ${theme.colors.gray2};
    width: 100%;
    padding-left: 16px;
    padding-right: 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 38px;
    margin-top: 13px;
`

export const CustomButton = styled(Button)`
    background: ${theme.colors.blue} !important;
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 1;
    display: flex;
    align-items: center;
    height: 32px;
    max-width: 200px;
    &:disabled {
        background: ${theme.colors.gray} !important;
    }
`

export const ConfirmButton = styled(Button)`
    background: ${theme.colors.green2} !important;
    margin-bottom: 16px !important;
    margin-top: 25px !important;
    width: 10rem;
    &:disabled {
        background: ${theme.colors.gray} !important;
    }
`

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`

export const Title = styled.h3`
    font-size: 21px;
    margin-top: 16px;
    margin-bottom: 22px;
`

export const CustomTextField = styled(TextField)`
    color: ${theme.colors.white} !important;
    background-color: ${theme.colors.gray2} !important;`

export const CustomTextFieldMui = styled(TextFieldMui)`
    width: 30rem;
    height: 3rem;
`

export const CustomInput = styled.input`
    position: absolute;
    align-items: center;
    opacity: 0;
    z-index: 2;
    height: 32px;
    max-width: 200px;
`

export const CustomContainerFile = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`

export const CustomTextParagraph = styled.p`
    color: ${theme.colors.red2};
    font-size: 12px;
    padding-right: 38px;
    padding-left: 15px;
`

export const CustomTextNameFile = styled.p`
    color: ${theme.colors.darkBlue};
    font-size: 13px;
    padding-left: 15px;
`

export const ContainerObservation = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`
export const ContainerFile = styled.div`
    display: flex;
    align-items: center;
    width: 70%;
    justify-content: space-between;
`

export const ContainerCheckBox = styled.div`
    display: flex;
    gap: 1rem;
    justify-content: center;
    p{
        font-size: 17px;
    }
`
